

export default {
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    },
    SET_QURBAN_LIST(state, payload){
        state.qurbanList = payload
    }
}
